// WorkspaceSwitcherItem — one workspace row for /studio/<owner> switchers.
//
// The old in-page `WorkspaceSwitcher` wrapper (Trigger + `_wsSwitcherMenuOpen`
// panel + document outside-click) was DELETED 2026-06-10: it was a dead,
// unmounted duplicate of the board workspace switcher, which now lives on the
// @symbo.ls/dropdown plugin (`boardWsSwitcher` in canvas/pages/studios.js).
// This row stays because the /studio sidebar's workspaces section
// (canvas/pages/dashboard.js) childExtends it.
//
// Data source: `root._workspacesForOwner` and `root._activeWsSlug` — both
// populated by the studios page; rows write via `el.router` so deep-links
// stay shareable.

export const WorkspaceSwitcherItem = {
  // FA204 / frank trap — ownerSlugFromPath used to be a bare module-scope
  // const read from inside `onClick` (a serialized factory); it reads as
  // undefined once this component is frank.toJSON'd for platform delivery
  // (workspace d6ea1142, project_frank_drops_module_local_helpers). Moved
  // into `scope`, called via `el.scope.ownerSlugFromPath`.
  scope: {
    ownerSlugFromPath: (path) => {
      const segs = (path || '').split('/').filter(Boolean)
      return segs[0] === 'workspaces' || segs[0] === 'studio' ? segs[1] || '' : ''
    }
  },
  tag: 'button',
  type: 'button',
  flow: 'x',
  align: 'center left',
  gap: 'Z1',
  width: '100%',
  padding: 'Z1 A',
  round: 'radiusControl',
  border: 'none',
  cursor: 'pointer',
  fontSize: 'Z2',
  fontWeight: '500',
  color: 'title',
  textAlign: 'left',
  // Active = the house `selected` wash; non-active returns undefined, NOT
  // 'transparent' — an inline transparent background outranks the `:hover`
  // class wash (same trap as AppOrgSwitcher, 261be696).
  background: (el, s) => (s.root?._activeWsSlug === s.slug ? 'selected' : undefined),
  ':hover': { background: 'hover' },

  Name: { tag: 'span', flex: '1', text: (el, s) => s.displayName || s.slug || 'workspace' },
  Check: {
    tag: 'span',
    color: 'green',
    text: (el, s) => (s.root?._activeWsSlug === s.slug ? '✓' : '')
  },

  onClick: (e, el, s) => {
    e.stopPropagation()
    const path =
      s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/')
    const owner = el.scope.ownerSlugFromPath(path)
    if (!owner) return
    const target = s.slug ? `/studio/${owner}/${s.slug}` : `/studio/${owner}`
    el.router(target, el.getRoot())
  }
}
